import {createFeature, StoreModule} from '@ngrx/store';
import {StoreKeys} from '../../models/store-keys';
import { usersSupervisedReducer } from './reducer/users-supervised.reducer';

export const usersSupervisedStoreConfig = StoreModule.forFeature(
  createFeature({
    name: StoreKeys.USERS_SUPERVISED,
    reducer: usersSupervisedReducer
  })
);

